var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.36338 11.9999C6.08738 11.9999 5.82338 11.8859 5.63438 11.6849L0.771382 6.50587C0.392382 6.10387 0.413382 5.47087 0.815382 5.09287C1.21838 4.71487 1.85138 4.73487 2.22838 5.13687L6.35338 9.52787L14.7614 0.325869C15.1354 -0.0831314 15.7674 -0.110131 16.1754 0.261869C16.5824 0.633869 16.6104 1.26687 16.2384 1.67387L7.10138 11.6739C6.91438 11.8799 6.64838 11.9979 6.37038 11.9999H6.36338Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.b8bf580d1a2e71cdfa53817dc0d09e01.svg";
export { ForwardRef as ReactComponent };